/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebSsologPost$Any$Params {
  'X-SessionId'?: string;
      body?: string
}

export function apiWebSsologPost$Any(http: HttpClient, rootUrl: string, params?: ApiWebSsologPost$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWebSsologPost$Any.PATH, 'post');
  if (params) {
    rb.header('X-SessionId', params['X-SessionId'], {});
    rb.body(params.body, '*');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWebSsologPost$Any.PATH = '/api/web/ssolog';
